export default {
	props: ['provider_data']
}


// WEBPACK FOOTER //
// ./src/common/Reviews/Step1/step1.js